export default __webpack_public_path__ + "static/media/pending 1.31ba37e9.svg";